<template>
  <div class="content"> <v-showdown :source="vuexApiData.items[0].fields.seRencontrerIntro"/></div>
</template>

<style scoped>
.content {
  margin-bottom: 2em;
}
</style>
<script>
export default {
  name: "EventIntro",
  props: { vuexApiData: Object }
};
</script>
